import type {
  NetworkLiveCaBreakdown,
  NetworkLiveCaSelectionParams,
  NetworkLiveTopProducts,
  NetworkLiveTopProductsSelectionParams,
} from '@gozoki/api-types'

import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchNetworkLiveCaBreakdown = async (
  selection: NetworkLiveCaSelectionParams,
): Promise<NetworkLiveCaBreakdown> => {
  const params: Record<string, string> = {}
  if (selection.storeIds?.length) params.storeIds = selection.storeIds.join(',')

  const response = await gozokiApiWithAuth.get<NetworkLiveCaBreakdown>(
    '/stores/get-network-live-ca-breakdown',
    { params: Object.keys(params).length ? params : undefined },
  )
  return response.data
}

export const fetchNetworkLiveTopProducts = async (
  selection: NetworkLiveTopProductsSelectionParams,
): Promise<NetworkLiveTopProducts> => {
  const params: Record<string, string> = {}
  if (selection.storeIds?.length) params.storeIds = selection.storeIds.join(',')
  if (selection.categoryIds?.length) params.categoryIds = selection.categoryIds.join(',')

  const response = await gozokiApiWithAuth.get<NetworkLiveTopProducts>(
    '/stores/get-network-live-top-products',
    { params: Object.keys(params).length ? params : undefined },
  )
  return response.data
}
